<template>
  <right-banner-template :title="title">
    <div class="train-device-content">
      <div class="train-device-grid">
        <div class="box" v-for="(device, index) in getTrainingDevice" :key="index">
          <div class="container">
            <img @contextmenu.prevent :src="cacheBuster(device.path)" class="image" style="width:100%">
            <div class="middle">
            <a>
              <button class="read-more" @click.prevent="navigateToDetail(device.link)">{{ moreInfo }}</button>
            </a>
            </div>
          </div>
          <p v-if="$store.state.lang === 'vn'" @click.prevent="navigateToDetail(device.link)">{{ device.name }}</p>
          <p v-else @click.prevent="navigateToDetail(device.link)">{{ device.enName }}</p>
        </div>
      </div>
    </div>
  </right-banner-template>
</template>

<script>
export default {
  props: ['title'],
  computed:
  {
    // $store.getters['facilities/finalDevices']
    getTrainingDevice () {
      return this.$store.getters['media/getTrainingDevides']
    },
    moreInfo () {
      if (this.$store.state.lang === 'vn') return 'Xem thêm'
      else return 'Read more'
    }
  },
  methods: {
    navigateToDetail (link) {
      // this.$router.push({ name: 'TDDetail', params: { url: 'td1' } })
      this.$router.push('/devices-utilities/training-devices/' + link)
    },
    cacheBuster (url) {
      return `${url}?cacheBuster=${new Date().getTime()}`
    }
  }
}
</script>

<style scoped>
  .container {
    position: relative;
    width: 100%;

    background: linear-gradient(to top, rgba(35, 37, 39, 1), rgba(68, 212, 212, 0));
    overflow: hidden;
    /* Thêm thuộc tính này để giới hạn vùng hiển thị */

  }

  .image {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    transition: .5s ease;
    backface-visibility: hidden;
    object-fit: cover;
  }

  .middle {
    transition: .5s ease;
    opacity: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: white;
  }

  .container:hover .image {
    transform: scale(1.1);
    mask-image: linear-gradient(to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1));
    /* opacity: 0.1; */
  }

  .container:hover .middle {
    opacity: 1;
  }

  .read-more {
    background-color: white;
    color: #333;
    border: none;
    padding: 8px 16px;
    cursor: pointer;
    font-size: 14px;
  }

  .read-more:hover {
    background-color: #ddd;
  }

  .train-device-content {
    padding: 0px 40px;
    margin-bottom: 60px;
  }

  .train-device-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 60px 90px;
  }

  .train-device-grid .box {
    width: 100%;
    max-height: 240px;
    text-align: center;
    cursor: pointer;
  }

  .box img {
    width: 100%;
    max-height: 220px;
    height: 220px;
    object-fit: cover;
  }

  .box p {
    margin-top: 5px;
    font-weight: bold;
    font-size: 17px;
  }

  @media (max-width: 1450px) {
    .train-device-grid {
      gap: 40px 50px;
    }

    .box p {
      font-size: 15px;
    }
  }

  @media (max-width: 650px) {
    .train-device-grid {
      grid-template-columns: 1fr;
    }

    .box img {
      max-width: 380px;
    }
  }

  @media (max-width: 485px) {
    .train-device-content {
      padding: 0px 10px;
    }
  }
</style>
